import Handlebars from "handlebars";

Handlebars.registerHelper("stripAllTags", function (string) {
  if (typeof string === "string") {
    string = string.replace(/(<([^>]+)>)/gi, "");
  }

  return string;
});
